'use client';
import styled from 'styled-components';

const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.darkGrey};
  margin-bottom: 0;
`;

export default Title;
